import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container user-list"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "pagination"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
const _hoisted_6 = {
  class: "dialog-footer"
};
import { onMounted, reactive, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage, ElMessageBox } from "element-plus";
import { dateFormat, disabledDate } from "@/utils/libs";
import { Delete, Plus, Search } from "@element-plus/icons-vue";

// 变量定义

export default {
  __name: 'Users',
  setup(__props) {
    const users = ref({
      page: 1,
      page_size: 15,
      items: []
    });
    const query = ref({
      username: "",
      page: 1,
      page_size: 15
    });
    const title = ref("添加用户");
    const vipImg = ref("/images/menu/member.png");
    const add = ref(true);
    const user = ref({
      chat_roles: [],
      chat_models: []
    });
    const pass = ref({
      username: "",
      password: "",
      id: 0
    });
    const roles = ref([]);
    const models = ref([]);
    const showUserEditDialog = ref(false);
    const showResetPassDialog = ref(false);
    const rules = reactive({
      username: [{
        required: true,
        message: "请输入账号",
        trigger: "blur"
      }],
      password: [{
        required: true,
        validator: (rule, value) => {
          return !(value.length > 16 || value.length < 8);
        },
        message: "密码必须为8-16",
        trigger: "blur"
      }],
      calls: [{
        required: true,
        message: "请输入提问次数"
      }, {
        type: "number",
        message: "请输入有效数字"
      }],
      chat_roles: [{
        required: true,
        message: "请选择聊天角色",
        trigger: "change"
      }],
      chat_models: [{
        required: true,
        message: "请选择AI模型",
        trigger: "change"
      }]
    });
    const loading = ref(true);
    const userEditFormRef = ref(null);
    onMounted(() => {
      fetchUserList(users.value.page, users.value.page_size);
      // 获取角色列表
      httpGet("/admin/role/list").then(res => {
        roles.value = res.data;
      }).catch(() => {
        ElMessage.error("获取聊天角色失败");
      });
      httpGet("/admin/model/list").then(res => {
        models.value = res.data;
      }).catch(e => {
        ElMessage.error("获取模型失败：" + e.message);
      });
    });
    const fetchUserList = function (page, pageSize) {
      query.value.page = page;
      query.value.page_size = pageSize;
      httpGet("/admin/user/list", query.value).then(res => {
        if (res.data) {
          // 初始化数据
          const arr = res.data.items;
          for (let i = 0; i < arr.length; i++) {
            arr[i].expired_time = dateFormat(arr[i].expired_time);
          }
          users.value.items = arr;
          users.value.total = res.data.total;
          users.value.page = res.data.page;
          user.value.page_size = res.data.page_size;
        }
        loading.value = false;
      }).catch(() => {
        ElMessage.error("加载用户列表失败");
      });
    };
    const handleSearch = () => {
      fetchUserList(users.value.page, users.value.page_size);
    };

    // 删除用户
    const removeUser = function (user) {
      ElMessageBox.confirm("此操作将会永久删除用户信息和聊天记录，确认操作吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        httpGet("/admin/user/remove", {
          id: user.id
        }).then(() => {
          ElMessage.success("操作成功！");
          fetchUserList(users.value.page, users.value.page_size);
        }).catch(e => {
          ElMessage.error("操作失败，" + e.message);
        });
      }).catch(() => {
        ElMessage.info("操作被取消");
      });
    };
    const userEdit = function (row) {
      user.value = row;
      title.value = "编辑用户";
      showUserEditDialog.value = true;
      add.value = false;
    };
    const addUser = () => {
      user.value = {
        chat_id: 0,
        chat_roles: [],
        chat_models: []
      };
      title.value = "添加用户";
      showUserEditDialog.value = true;
      add.value = true;
    };
    const saveUser = function () {
      userEditFormRef.value.validate(valid => {
        if (valid) {
          showUserEditDialog.value = false;
          console.log(user.value);
          httpPost("/admin/user/save", user.value).then(res => {
            ElMessage.success("操作成功！");
            if (add.value) {
              users.value.items.push(res.data);
            }
          }).catch(e => {
            ElMessage.error("操作失败，" + e.message);
          });
        } else {
          return false;
        }
      });
    };
    const userIds = ref([]);
    const handleSelectionChange = function (rows) {
      userIds.value = [];
      rows.forEach(row => {
        userIds.value.push(row.id);
      });
    };
    const multipleDelete = function () {
      ElMessageBox.confirm("此操作将会永久删除用户信息和聊天记录，确认操作吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        loading.value = true;
        httpGet("/admin/user/remove", {
          ids: userIds.value
        }).then(() => {
          ElMessage.success("操作成功！");
          fetchUserList(users.value.page, users.value.page_size);
          loading.value = false;
        }).catch(e => {
          ElMessage.error("操作失败，" + e.message);
          loading.value = false;
        });
      }).catch(() => {
        ElMessage.info("操作被取消");
      });
    };
    const resetPass = row => {
      showResetPassDialog.value = true;
      pass.value.id = row.id;
      pass.value.username = row.username;
    };
    const doResetPass = () => {
      httpPost("/admin/user/resetPass", pass.value).then(() => {
        ElMessage.success("操作成功！");
        showResetPassDialog.value = false;
      }).catch(e => {
        ElMessage.error("操作失败，" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_button_group = _resolveComponent("el-button-group");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        modelValue: query.value.username,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.value.username = $event),
        placeholder: "账号",
        class: "handle-input mr10"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Search),
        onClick: handleSearch
      }, {
        default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("搜索")])),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        type: "success",
        icon: _unref(Plus),
        onClick: addUser
      }, {
        default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("新增用户")])),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        type: "danger",
        icon: _unref(Delete),
        onClick: multipleDelete
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode("删除")])),
        _: 1
      }, 8, ["icon"])]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: users.value.items,
          border: "",
          class: "table",
          "row-key": row => row.id,
          onSelectionChange: handleSelectionChange,
          "table-layout": "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "38"
          }), _createVNode(_component_el_table_column, {
            prop: "id",
            label: "ID"
          }), _createVNode(_component_el_table_column, {
            label: "账号"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.username), 1), scope.row.vip ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              src: vipImg.value,
              style: {
                "height": "20px",
                "position": "relative",
                "top": "5px",
                "left": "5px"
              }
            }, null, 8, ["src"])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "mobile",
            label: "手机"
          }), _createVNode(_component_el_table_column, {
            prop: "email",
            label: "邮箱"
          }), _createVNode(_component_el_table_column, {
            prop: "nickname",
            label: "昵称"
          }), _createVNode(_component_el_table_column, {
            prop: "power",
            label: "剩余算力"
          }), _createVNode(_component_el_table_column, {
            label: "状态",
            width: "80"
          }, {
            default: _withCtx(scope => [scope.row.status ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "success"
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("正常")])),
              _: 1
            })) : (_openBlock(), _createBlock(_component_el_tag, {
              key: 1,
              type: "danger"
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("停用")])),
              _: 1
            }))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "过期时间"
          }, {
            default: _withCtx(scope => [scope.row['expired_time'] ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(scope.row["expired_time"]), 1)) : (_openBlock(), _createBlock(_component_el_tag, {
              key: 1
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("长期有效")])),
              _: 1
            }))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "注册时间"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "200"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button_group, {
              class: "ml-4"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: $event => userEdit(scope.row)
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("编辑")])),
                _: 2
              }, 1032, ["onClick"]), _createVNode(_component_el_button, {
                size: "small",
                type: "danger",
                onClick: $event => removeUser(scope.row)
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode("删除")])),
                _: 2
              }, 1032, ["onClick"]), _createVNode(_component_el_button, {
                size: "small",
                type: "success",
                onClick: $event => resetPass(scope.row)
              }, {
                default: _withCtx(() => _cache[27] || (_cache[27] = [_createTextVNode("重置密码")])),
                _: 2
              }, 1032, ["onClick"])]),
              _: 2
            }, 1024)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"]), _createElementVNode("div", _hoisted_4, [users.value.total > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 0,
          background: "",
          layout: "total, prev, pager, next",
          "current-page": users.value.page,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => users.value.page = $event),
          "page-size": users.value.page_size,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => users.value.page_size = $event),
          total: users.value.total,
          onCurrentChange: _cache[3] || (_cache[3] = $event => fetchUserList(users.value.page, users.value.page_size))
        }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: showUserEditDialog.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => showUserEditDialog.value = $event),
        title: title.value,
        "close-on-click-modal": false,
        width: "50%"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = $event => showUserEditDialog.value = false)
        }, {
          default: _withCtx(() => _cache[28] || (_cache[28] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveUser
        }, {
          default: _withCtx(() => _cache[29] || (_cache[29] = [_createTextVNode("提交")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: user.value,
          "label-width": "100px",
          ref_key: "userEditFormRef",
          ref: userEditFormRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "账号：",
            prop: "username"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: user.value.username,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => user.value.username = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "手机：",
            prop: "mobile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: user.value.mobile,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => user.value.mobile = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "邮箱：",
            prop: "email"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: user.value.email,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => user.value.email = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), add.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "密码：",
            prop: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: user.value.password,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => user.value.password = $event),
              autocomplete: "off",
              placeholder: "8-16位"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "剩余算力：",
            prop: "power"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: user.value.power,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => user.value.power = $event),
              modelModifiers: {
                number: true
              },
              autocomplete: "off",
              placeholder: "0"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "有效期：",
            prop: "expired_time"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: user.value.expired_time,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => user.value.expired_time = $event),
              type: "datetime",
              placeholder: "选择日期",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              "disabled-date": _unref(disabledDate)
            }, null, 8, ["modelValue", "disabled-date"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "聊天角色",
            prop: "chat_roles"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: user.value.chat_roles,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => user.value.chat_roles = $event),
              multiple: "",
              filterable: true,
              placeholder: "选择聊天角色，多选"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.key,
                  label: item.name,
                  value: item.key
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模型权限",
            prop: "chat_models"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: user.value.chat_models,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => user.value.chat_models = $event),
              multiple: "",
              filterable: true,
              placeholder: "选择AI模型，多选"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(models.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "启用状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: user.value.status,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => user.value.status = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "开通VIP"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: user.value.vip,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => user.value.vip = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: showResetPassDialog.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => showResetPassDialog.value = $event),
        title: "重置密码",
        width: "50%"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: doResetPass
        }, {
          default: _withCtx(() => _cache[30] || (_cache[30] = [_createTextVNode("提交")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "100px",
          ref_key: "userEditFormRef",
          ref: userEditFormRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "账户："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: pass.value.username,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => pass.value.username = $event),
              autocomplete: "off",
              readonly: "",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新密码："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: pass.value.password,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => pass.value.password = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 512)]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, loading.value]]);
    };
  }
};